import { OneOrArray } from '../../../types';
import {
  OxygenId,
  RfiCategory,
  RfiCostImpact,
  RfiDiscipline,
  RfiId,
  RfiPriority,
  RfiScheduleImpact,
  DateRange,
} from '../common';

export interface GetRfisRequest {
  limit?: number;
  offset?: number;
  sortBy?: RfisSortOption | RfisSortOption[];
  fields?: RfiFieldOption | RfiFieldOption[];
  filterBy?: RFIFilter;
}

export interface RFIFilter {
  search?: string;
  id?: OneOrArray<RfiId>;
  status?: OneOrArray<RfiFilterStatus>;
  includeHidden?: boolean;
  linkedDocument?: OneOrArray<string>;
  linkedDocumentVersion?: number;
  assignedTo?: OneOrArray<OxygenId>;
  createdAt?: DateRange;
  filterCreatedBy?: OneOrArray<OxygenId>;
  dueDate?: DateRange;
  costImpact?: OneOrArray<RfiCostImpact>;
  scheduleImpact?: OneOrArray<RfiScheduleImpact>;
  priority?: OneOrArray<RfiPriority>;
  discipline?: OneOrArray<RfiDiscipline>;
  category?: OneOrArray<RfiCategory>;
}

export enum RfiFilterStatus {
  Draft = 'draft',
  Submitted = 'submitted',
  Open = 'open',
  Answered = 'answered',
  Closed = 'closed',
  Rejected = 'rejected',
  Void = 'void',
  All = 'all',
}

export type RfisSortOption =
  | 'createdAt DESC'
  | 'createdAt ASC'
  | 'status DESC'
  | 'status ASC'
  | 'dueDate DESC'
  | 'dueDate ASC'
  | 'title DESC'
  | 'title ASC'
  | 'location DESC'
  | 'location ASC'
  | 'updatedAt DESC'
  | 'updatedAt ASC'
  | 'costImpact ASC'
  | 'costImpact DESC'
  | 'scheduleImpact ASC'
  | 'scheduleImpact DESC'
  | 'priority ASC'
  | 'priority DESC'
  | 'discipline ASC'
  | 'discipline DESC'
  | 'category ASC'
  | 'category DESC'
  | 'reference ASC'
  | 'reference DESC'
  | 'customIdentifier ASC'
  | 'customIdentifier DESC';

export type RfiFieldOption =
  | 'id'
  | 'customIdentifier'
  | 'title'
  | 'question'
  | 'status'
  | 'assignedTo'
  | 'assignedToType'
  | 'dueDate'
  | 'location'
  | 'linkedDocument'
  | 'linkedDocumentVersion'
  | 'linkedDocumentCloseVersion'
  | 'officialResponse'
  | 'respondedAt'
  | 'respondedBy'
  | 'createdBy'
  | 'createdAt'
  | 'updatedBy'
  | 'updatedAt'
  | 'closedAt'
  | 'closedBy'
  | 'containerId'
  | 'suggestedAnswer'
  | 'coReviewers'
  | 'distributionList'
  | 'answeredAt'
  | 'answeredBy'
  | 'costImpact'
  | 'scheduleImpact'
  | 'priority'
  | 'discipline'
  | 'category'
  | 'reference'
  | 'sheetMetadata'
  | 'attachmentsCount'
  | 'commentsCount'
  | 'managerId'
  | 'constructionManagerId'
  | 'architectId'
  | 'reviewerId';
